import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABDHorizontalSpacing.module.scss';

export enum HorizontalSpacingType {
  X05 = 'HORIZONTAL_X05',
  X1 = 'HORIZONTAL_X1',
  X2 = 'HORIZONTAL_X2',
  X3 = 'HORIZONTAL_X3',
}

export interface HorizontalSpacingProps {
  type: HorizontalSpacingType;
}

export const HorizontalSpacing = React.memo<HorizontalSpacingProps>((props) => {
  const { type } = props;

  const ContainerStyles = React.useMemo(() => {
    const containerStyles: string[] = [classNames.container];

    switch (type) {
      case HorizontalSpacingType.X05:
        containerStyles.push(classNames.x05);
        break;
      case HorizontalSpacingType.X1:
        containerStyles.push(classNames.x1);
        break;
      case HorizontalSpacingType.X2:
        containerStyles.push(classNames.x2);
        break;
      case HorizontalSpacingType.X3:
        containerStyles.push(classNames.x3);
        break;
    }

    return StyleUtil.mergeClassNames(containerStyles);
  }, [type]);

  return <div className={ContainerStyles}></div>;
});
